module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bannerPlaceHolderForComboTab || _vm.bannerPlaceHolderForKidsTab) ? _c('div', {
    staticClass: "tabs-wrapper d-flex flex-row align-items-center text-uppercase",
    class: _vm.callerComp === 'search' && _vm.isProductsLoad ? 'search-product-loading' : ''
  }, [(_vm.bannerPlaceHolderForComboTab && _vm.showMenWebMenu && _vm.anyTwoGenderKeysTrue && !_vm.isKidsGenderRouteActive) ? _c('div', {
    staticClass: "col d-flex flex-row align-items-center justify-content-center gender-text-container",
    class: [_vm.tabsCountDataArr[0].is_men ? 'active-tab-class' : 'd-active-tab-class'],
    on: {
      "click": function($event) {
        _vm.updateLandingCategory('men')
      }
    }
  }, [_c('div', {
    staticClass: "gender-text-wrapper",
    class: _vm.selectedGender === 'men' ? 'selected-tab-class' : ''
  }, [_c('span', {
    staticClass: "gender-text"
  }, [_vm._v("Men")])])]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForComboTab && _vm.showWomenWebMenu && _vm.anyTwoGenderKeysTrue && !_vm.isKidsGenderRouteActive) ? _c('div', {
    staticClass: "col d-flex flex-row align-items-center justify-content-center gender-text-container",
    class: [_vm.tabsCountDataArr[0].is_women ? 'active-tab-class' : 'd-active-tab-class'],
    on: {
      "click": function($event) {
        _vm.updateLandingCategory('women')
      }
    }
  }, [_c('div', {
    staticClass: "gender-text-wrapper",
    class: _vm.selectedGender === 'women' ? 'selected-tab-class' : ''
  }, [_c('span', {
    staticClass: "gender-text"
  }, [_vm._v("Women")])])]) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForKidsTab && _vm.showKidsWebMenu && _vm.anyTwoGenderKeysTrue && !_vm.isKidsGenderRouteActive) ? _c('div', {
    staticClass: "col d-flex flex-row align-items-center justify-content-center gender-text-container",
    class: [_vm.tabsCountDataArr[0].is_kids ? 'active-tab-class' : 'd-active-tab-class'],
    on: {
      "click": function($event) {
        _vm.updateLandingCategory('kids')
      }
    }
  }, [_c('div', {
    staticClass: "gender-text-wrapper",
    class: _vm.selectedGender === 'kids' ? 'selected-tab-class' : ''
  }, [_c('span', {
    staticClass: "gender-text"
  }, [_vm._v("Kids")])])]) : _vm._e(), _vm._v(" "), (_vm.isKidsGenderRouteActive) ? _c('div', {
    staticClass: "col d-flex flex-row align-items-center justify-content-center gender-text-container",
    class: [_vm.tabsCountDataArr[0].is_kids ? 'active-tab-class' : 'd-active-tab-class'],
    on: {
      "click": function($event) {
        _vm.updateLandingCategory('boys')
      }
    }
  }, [_c('div', {
    staticClass: "gender-text-wrapper",
    class: _vm.selectedGender === 'boys' ? 'selected-tab-class' : ''
  }, [_c('span', {
    staticClass: "gender-text"
  }, [_vm._v("Boys")])])]) : _vm._e(), _vm._v(" "), (_vm.isKidsGenderRouteActive) ? _c('div', {
    staticClass: "col d-flex flex-row align-items-center justify-content-center gender-text-container",
    class: [_vm.tabsCountDataArr[0].is_kids ? 'active-tab-class' : 'd-active-tab-class'],
    on: {
      "click": function($event) {
        _vm.updateLandingCategory('girls')
      }
    }
  }, [_c('div', {
    staticClass: "gender-text-wrapper",
    class: _vm.selectedGender === 'girls' ? 'selected-tab-class' : ''
  }, [_c('span', {
    staticClass: "gender-text"
  }, [_vm._v("Girls")])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a99c91e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/GenderTabs.vue
// module id = 1056
// module chunks = 111